import React, { createContext, useContext } from 'react';
import { css } from '@emotion/react';

import { fontSizes, colorVariables, colors } from '@gumtree/ui-library/src/base/theme';
import { trackGA4PreNav } from '@gumtree/shared/src/util/ga4-shared';
import { getDomainFromUrl } from '@gumtree/shared/src/util/url-service';
import {
    setCategoryBrpEntryCookie,
    type CategoryBrpEntry,
} from '@gumtree/shared/src/util/category-brp-entry-cookie';
import {
    getL2CategoryIdBySeoName,
    L2CategorySeoName,
} from '@gumtree/shared/src/util/category-mapping';

export const MhcDesktopSubNavContext = createContext(false);

export default function SubNavPanelSectionItem({
    href,
    label,
    seoName,
    sectionTitle,
    brpEntry,
    ...props
}: Props) {
    const isMhcDesktop = useContext(MhcDesktopSubNavContext);

    return (
        <li {...props} css={liStyle}>
            <a
                onClick={() => {
                    if (brpEntry) {
                        setCategoryBrpEntryCookie(brpEntry);
                    }
                    trackGA4PreNav<GA4.ClickNavigationMenu>({
                        event: 'click_navigation_menu',
                        linkDomain: getDomainFromUrl(href),
                        linkText: label,
                        linkURL: href,
                        navigationCategory: seoName as L2CategorySeoName,
                        navigationCategoryId:
                            (seoName && getL2CategoryIdBySeoName(seoName as L2CategorySeoName)) ||
                            undefined,
                        navigationHeader: sectionTitle,
                        navigationHierarchy: 'sub category',
                    });
                }}
                href={href}
                css={isMhcDesktop ? mhcDesktopLinkStyle : linkStyle}
            >
                {label}
            </a>
        </li>
    );
}
interface Props {
    href: string;
    label: string;
    seoName?: string;
    sectionTitle: NavRibbonSectionTitle;
    brpEntry?: CategoryBrpEntry;
}

export type NavRibbonSectionTitle = 'Browse by' | 'Discover more in our guides';

const liStyle = css`
    list-style-type: none;
    margin-bottom: 10px;
`;

const linkStyle = css`
    display: block;
    font-size: ${fontSizes.base};
    line-height: 22px;
    color: ${colorVariables.textNeutral};

    &:hover,
    &:focus {
        text-decoration: underline;
    }
`;

const mhcDesktopLinkStyle = css`
    display: block;
    font-family: 'San Francisco Text', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    font-size: ${fontSizes.base};
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    color: ${colorVariables.textNeutral};

    &:hover,
    &:focus {
        color: var(--color-accent-default, ${colors.votAccent});
        text-decoration: none;
    }
`;
